(function () {
  angular.module("akitabox.asset.list", [
    "ui.router",
    "akitabox.constants",
    "akitabox.core.router",
    "akitabox.core.services.asset",
    "akitabox.core.services.pinValue",
  ]);
})();
